import type { Meta, StoryObj } from "@storybook/react";

import { Text } from "@/ui/core";
import { Box, VStack } from "@/ui/layout";
import {
  MotionParallaxLayer,
  useMotionParallax,
} from "@/ui/layout/animated/MotionParallaxLayer";
import { ColorToken } from "@/ui/theme/tokens";

const MotionParallaxDemo = () => {
  const motion = useMotionParallax();
  // eslint-disable-next-line max-params -- Array.from callback requires index
  const layers = Array.from({ length: 7 }, (_, index) => {
    const depth = -0.2 + index * 0.2;
    return { depth, label: `Layer (depth: ${depth.toFixed(1)})` };
  });

  return (
    <VStack gap={16} padding={20} width="100%">
      <Text color={ColorToken.NeutralSecondary} testID="hint" variant="caption">
        Tilt your device to see the parallax effect. Each layer shifts at a
        different rate. Negative depth moves opposite to tilt.
      </Text>
      <VStack gap={12}>
        {layers.map((layer) => (
          <MotionParallaxLayer
            depth={layer.depth}
            key={layer.label}
            motion={motion}
          >
            <Box
              alignItems="center"
              backgroundColor={ColorToken.Primary10}
              borderRadius={12}
              justifyContent="center"
              padding={20}
            >
              <Text testID={`layer-${layer.depth}`} variant="body">
                {layer.label}
              </Text>
            </Box>
          </MotionParallaxLayer>
        ))}
      </VStack>
    </VStack>
  );
};

const StoryMeta: Meta = {
  title: "Layout/Animated/Motion Parallax Layer",
};

type Story = StoryObj;

const Default: Story = {
  render: () => <MotionParallaxDemo />,
};

export { Default };
export default StoryMeta;
